module.exports = __webpack_public_path__ + "static/media/PATS_5-1018w.773a6f04.png";